<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="12" md="6">
                    <span>Users</span>
                  </b-col>
                  <!-- <b-col cols="12" md="6">
                    <b-dropdown
                      variant="outline-primary"
                      size="sm"
                      id="dropdown-1"
                      :text="updateName"
                    >
                      <b-dropdown-item
                        v-for="(item,i) in userTypes"
                        :key="i"
                        @click="getData(item)"
                      >{{item.name}}</b-dropdown-item>
                    </b-dropdown>
                  </b-col> -->
                  
                </b-row>
              </b-col>
              <b-col cols="4"></b-col>
              <b-col v-if="updateName=='All Users'" cols="2">
              
               
                <b-button
                  class="buttonlink"
                  to="/addUser"
                  v-b-modal.modal-lg
                  variant="link"
                  style="color:primary"
                >
                  <b>+ Add New User</b>
                </b-button>
              
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="users"
            :fields="fields"
            @row-clicked="rowClicked"
          >
            <!-- <template slot="photo" slot-scope="data">
              <img v-if="data.item.photo" :src="baseURL+'/u/'+data.item.photo" />
              <span v-else>-</span>
            </template> -->
            <template slot="name" slot-scope="data">
              <strong v-if="data.item.name">{{data.item.name}}</strong>
              <span v-else>-</span>
            </template>
            <template slot="usrname" slot-scope="data">
              <strong v-if="data.item.username">{{data.item.username}}</strong>
              <span v-else>-</span>
            </template>
            <template slot="phone" slot-scope="data">
              <span v-if="data.item.phone">{{data.item.phone}}</span>
              <span v-else>-</span>
            </template>
            
            <template slot="email" slot-scope="data">
              <span v-if="data.item.email">{{data.item.email}}</span>
              <span v-else>-</span>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalUsers"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextPage"
            />
          </nav>
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      users: [],
      fields: [
        { key: "name", label: "Name", sortable: false },
        { key: "usrname", label: "User Name", sortable: false },
        { key: "phone", label: "Phone", sortable: false },
        { key: "email", label: "Email", sortable: false },
        
      ],
      totalUsers: 0,
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      updateName: "All Users",
      userTypes: [
        { name: "All Users", route: "/user/allUsers" },
        // { name: "Clients", route: "/user/allClients" },
        // { name: "Administrators", route: "/user/allAdmins" },
        { name: "Deactivated Users", route: "/user/BannedUsers" }
      ],
      currentUser: null
    };
  },
  mounted() {
    this.getData(this.userTypes[0]);
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getData(this.currentUser);
    },
    getData(item) {
      if (item != this.currentUser) 
      this.currentPage = 1;
      this.currentUser = item;
      this.updateName = item.name;
      this.appLoading = true;
      axios({
        url: item.route,
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          count: this.perPage,
          page: this.currentPage
        }
      })
        .then(response => {
          this.users = response.data.data;
          this.totalUsers = response.data.count;
          this.appLoading = false;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    rowClicked(item) {
      this.$router.push("/Users/" + item._id);
    }
  }
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
